// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__jFPe5","active":"RoomScene_active__AWMoI"};